export default "/images/image_8.jpg?ca84c4dcde2bf7f8b12d0c9531d60a04";